<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.00002 10.986C7.00002 11.2512 7.10537 11.5056 7.29291 11.6931C7.48045 11.8806 7.7348 11.986 8.00002 11.986C8.26523 11.986 8.51959 11.8806 8.70712 11.6931C8.89466 11.5056 9.00002 11.2512 9.00002 10.986V3.828L12.243 7.071L13.657 5.657L8.00002 0L2.34302 5.657L3.75702 7.071L7.00002 3.83V10.987V10.986Z"
      fill="#F6F6F6"
    />
    <path
      d="M0 10H2V14H14V10H16V14C16 14.5304 15.7893 15.0391 15.4142 15.4142C15.0391 15.7893 14.5304 16 14 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14V10Z"
      fill="#F6F6F6"
    />
  </svg>
</template>
<script>
export default {
  name: "UploadIcon",
};
</script>
